import React from "react";

import { useIntl } from "react-intl";

import { TextField } from "@mapmycustomers/ui";

import Report from "@app/types/Report";

import styles from "./Toolbar.module.scss";

interface Props {
  onDescriptionChange: (description: string) => void;
  onNameChange: (name: string) => void;
  report: Partial<Report>;
}

const Toolbar: React.FC<Props> = ({ onDescriptionChange, onNameChange, report }) => {
  const intl = useIntl();
  return (
    <section className={styles.container}>
      <TextField
        className={styles.nameField}
        label={intl.formatMessage({
          id: "reports.edit.toolbar.name",
          defaultMessage: "Export Name",
          description: "Report Name field title on the edit report page",
        })}
        labelPosition="top"
        onChange={onNameChange}
        size="middle"
        value={report.name}
      />
      <TextField
        className={styles.descriptionField}
        label={intl.formatMessage({
          id: "reports.edit.toolbar.description",
          defaultMessage: "Export Description",
          description: "Report Description field title on the edit report page",
        })}
        labelPosition="top"
        onChange={onDescriptionChange}
        size="middle"
        value={report.description}
      />
    </section>
  );
};

export default Toolbar;
